import React from "react";

export const pct = (v) => `${Math.round((v || 0) * 100)}%`;

// Percentage-point change between two rates, e.g. 0.31 → 0.35 renders "▲ 4 pts".
export function Delta({ value }) {
  if (value == null) return <span className="muted">—</span>;
  const p = Math.round(value * 100);
  const cls = p > 0 ? "delta delta-up" : p < 0 ? "delta delta-down" : "delta delta-flat";
  const arrow = p > 0 ? "▲" : p < 0 ? "▼" : "–";
  return <span className={cls}>{arrow} {Math.abs(p)} pts</span>;
}

export const runLabel = (r) =>
  r.completedAt ? new Date(r.completedAt).toLocaleDateString() : `#${r.runNumber}`;
